import React from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import "./Login.css";
import { useState } from "react";
import axios from "axios";
import { url } from "../../App";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export const Login = () => {
  const [open, setOpen] = React.useState(false);
  const [pass, setPass] = useState("password");
  const [userId, setUserId] = useState("");
  const [userPass, setUserPass] = useState("");

  const navigate = useNavigate();

  const handleCheckbox = (e) => {
    if (e.target.checked === true) {
      setPass("text");
    } else {
      setPass("password");
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    console.log("Logging In");
    setOpen(true);
    axios
      .post(url + "/api/login", {
        email: userId,
        password: userPass,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === true) {
          setOpen(false);
          toast.success("Logged in Successfully!");
          localStorage.setItem("CodeCPV", res.data.data.company_code);
          localStorage.setItem("NameCPV", res.data.data.name);
          localStorage.setItem("IdCPV", res.data.data._id);
          setTimeout(() => {
            navigate("/1");
          }, 2000);
        } else {
          setOpen(false);
          toast.error("Please Check User Id or Password");
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
        toast.error(err.message);
        return;
      });
  };

  return (
    <>
      <div className="main-login">
        <div style={{ margin: "2rem" }}>
          <img src={Credin} alt="Credin Logo" width="150" />
        </div>
        <div className="container-login">
          <form onSubmit={handleLogin}>
            <div className="div-login">
              <label>User Id</label>
              <input
                required
                type="text"
                style={{ height: "2rem" }}
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
              />
            </div>
            <div className="div-login">
              <label>Password</label>
              <input
                required
                type={pass}
                style={{ height: "2rem" }}
                value={userPass}
                onChange={(e) => setUserPass(e.target.value)}
              />
            </div>
            <input type="checkbox" onChange={(e) => handleCheckbox(e)} />
            <label>Show Password</label>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: ".5rem",
              }}
            >
              <button className="btn-login" type="submit">
                Login
              </button>
            </div>
          </form>
        </div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <ToastContainer position="top-center" />
      </div>
    </>
  );
};
